<template>
<div style="position: relative;">
  <div class="dashboard" :style="{width:view_width+'px',height:view_height+'px'}">



    <!-- 左一 -->
    <div class='mini-box lf1 tp1'>
      <div id='left_one_chart' style="width: 100%;height: 100%;"></div>
      <div class="mini-box-title">Total mapping records & </br>infringing hosting URLs reported</div>
    </div>
    <!-- 左二 -->
    <div class='mini-box lf1 tp2'>
       <div class="mini-box-title">Mapping Records</div>
       <div class="p_abs lf_5 tp_30 ftsize15"> Lask week</div>
       <div class="p_abs lf_5 tp_45 ftsize50">8.08 K</div>
       <div class="p_abs lf_60 tp_30 ftsize15">15-week Average</div>
       <div class="p_abs lf_60 tp_40 ftsize20">5.7 K</div>
       <div class="p_abs lf_60 tp_55 ftsize15">Total</div>
       <div class="p_abs lf_60 tp_65 ftsize20">270 K</div>
    </div>
    <!-- 左三 -->
    <div class='mini-box lf1 tp3'>
      <div class="mini-box-title">Infringing Hosting URLs Reported</div>
      <div class="p_abs lf_5 tp_30 ftsize15"> Lask week</div>
      <div class="p_abs lf_5 tp_45 ftsize50">7.61 K</div>
      <div class="p_abs lf_60 tp_30 ftsize15">15-week Average</div>
      <div class="p_abs lf_60 tp_40 ftsize20">5.7 K</div>
      <div class="p_abs lf_60 tp_55 ftsize15">Total</div>
      <div class="p_abs lf_60 tp_65 ftsize20">570 K</div>
    </div>
    <!-- 左四 -->
    <div class='mini-box lf1 tp4'>
      <div class="mini-box-title">Linking Sites Configuration</div>
      <div class="p_abs lf_5 tp_30 ftsize15"> Lask week</div>
      <div class="p_abs lf_5 tp_40 ftsize10"> Link sites</div>
      <div class="p_abs lf_5 tp_45 ftsize50">80</div>
      <div class="p_abs lf_25 tp_40 ftsize10"> New Hosting sites</div>
      <div class="p_abs lf_35 tp_45 ftsize50">7</div>
      <div class="p_abs lf_60 tp_30 ftsize15">Pending</div>
      <div class="p_abs lf_60 tp_40 ftsize20">860</div>
      <div class="p_abs lf_60 tp_55 ftsize15">Finished</div>
      <div class="p_abs lf_60 tp_65 ftsize20">680</div>
    </div>
    <!-- 右一 -->
    <div class='mini-box lf3 tp1'>
      <div class="mini-box-title">Pending Verification</div>
      <div class="p_abs tp_35 ftsize50 wh100">1322222K</div>
    </div>
    <!-- 右二 -->
    <div class='mini-box lf3 tp2'>
      <div class="mini-box-title">Total Active Sites (Last week)</div>
      <div class="p_abs lf_5 tp_30 ftsize15">Linking</div>
      <div class="p_abs lf_5 tp_45 ftsize25"><span class="ftsize40">160</span>/680</div>
      <div class="p_abs lf_60 tp_30 ftsize15">Hosting</div>
      <div class="p_abs lf_60 tp_45 ftsize25"><span class="ftsize40">54</span>/89</div>

    </div>
    <!-- 右三 -->
    <div class='mini-box lf3 tp3'>
      <div class="mini-box-title">Abnomail Linking Sites:<span class="ftsize20 ftred">35</span></div>

      <!-- <div class="p_abs tp_20 wh100 hh90">
        <div class="p_abs wh100 lf_4 hh13">
          <div class="wh46 tx_l flt_l bdr_pink hh100 ftsize10">No new URL</div>
          <div class="wh46 tx_l flt_l bgc_pink hh100" :style="{width:46*ab_linking_data.no_new_url/maxData(ab_linking_data)+'%'}">{{ab_linking_data.no_new_url}}</div>
        </div>
        <div class="p_abs wh100 lf_4 hh13 tp_20">
          <div class="wh46 tx_l flt_l bdr_pink hh100 ftsize10">No matched series URL</div>
          <div class="wh46 tx_l flt_l bgc_pink hh100" :style="{width:46*ab_linking_data.no_matched_series_url/maxData(ab_linking_data)+'%'}">{{ab_linking_data.no_matched_series_url}}</div>
        </div>
        <div class="p_abs wh100 lf_4 hh13 tp_40">
          <div class="wh46 tx_l flt_l bdr_pink hh100 ftsize10">No matched episode URL</div>
          <div class="wh46 tx_l flt_l bgc_pink hh100" :style="{width:46*ab_linking_data.no_matched_episode_url/maxData(ab_linking_data)+'%'}">{{ab_linking_data.no_matched_episode_url}}</div>
        </div>
        <div class="p_abs wh100 lf_4 hh13 tp_60">
          <div class="wh46 tx_l flt_l bdr_pink hh100 ftsize10">no host URL refreshed</div>
          <div class="wh46 tx_l flt_l bgc_pink hh100" :style="{width:46*ab_linking_data.no_host_url_refreshed/maxData(ab_linking_data)+'%'}">{{ab_linking_data.no_host_url_refreshed}}</div>
        </div>
      </div> -->
      <div class="p_abs tp_20 wh100 hh90">
        <div class="p_abs wh100 lf_4 hh13" v-for="v,k,i in ab_linking_data" :style="{top:i*20+'%'}">
          <div class="wh46 tx_l flt_l bdr_pink hh100 ftsize10">{{formatTitle(k)}}</div>
          <div class="wh46 tx_l flt_l bgc_pink hh100 bdr_pink ft_bold" :style="{width:46*v/maxData(ab_linking_data)+'%'}">&nbsp;{{v}}</div>
        </div>
      </div>

    </div>
    <!-- 右四 -->
    <div class='mini-box lf3 tp4'>
      <div class="mini-box-title">Abnomal Hosting Sites:<span class="ftsize20 ftred">28</span></div>
      <div class="p_abs tp_15 wh100 hh90">
        <div class="p_abs wh100 lf_4 hh9" v-for="v,k,i in ab_hosting_data" :style="{top:i*15+'%'}">
          <div v-if="i%2==0" class="wh46 tx_l flt_l bdr_pink hh100 ftsize10">{{formatTitle(k)}}</div>
          <div v-else class="wh46 tx_l flt_l hh100 ftsize10">{{formatTitle(k)}}</div>
          <div v-if="i%2==0" class="wh46 tx_l flt_l bgc_pink hh100 bdr_pink ftsize10 ft_bold" :style="{width:40*v/maxData2(ab_hosting_data)+'%'}">&nbsp;{{v}}</div>
          <div v-else class="wh46 tx_l flt_l hh100 ft_bold" >&nbsp;{{v}}</div>
        </div>
      </div>


    </div>
    <!-- 中大 -->
    <div class='max-box lf2 tp1'>
      <div id='max_chart' style="width: 100%;height: 100%;"></div>
      <div class="mini-box-title"><span>New mapping records & infringing </span><br/><span>hosting URLs reported</span></div>
    </div>
    <!-- 中小 -->
    <div class='mid-box lf2 tpm2'>
      <div id='mid_chart' style="width: 100%;height: 100%;"></div>
      <div class="mini-box-title">Mapping Table Verification</div>
    </div>




  </div>
</div>
</template>

<script>
export default {
  name: 'Monitoring',
  data () {
    return {
      title: 'Monitoring page',
      view_height: document.documentElement.clientHeight-40,
      view_width: document.documentElement.clientWidth,
      ab_linking_data:{
        no_new_url:35,
        no_matched_series_url:8,
        no_matched_episode_url:5,
        no_host_url_refreshed:23
      },
      ab_hosting_data:{
        download_failed_sites:36,
        download_failed_urls:7882283,
        parse_failed_sites:56,
        parse_failed_urls:488000,
        status_check_failed_sites:24,
        status_check_failed_urls:286298
      },
      title_dic:{
        no_new_url:'No new URL',
        no_matched_series_url:'No matched series URL',
        no_matched_episode_url:'No matched episode URL',
        no_host_url_refreshed:'No host URL refreshed',
        download_failed_sites:'Download failed sites',
        download_failed_urls:'Download failed URLs',
        parse_failed_sites:'Parse failed sites',
        parse_failed_urls:'Parse failed URLs',
        status_check_failed_sites:'Status check failed sites',
        status_check_failed_urls:'Status check failed URLs'
      }
    }
  },
  mounted () {
      this.drawMidMap();
      this.drawMaxMap();
      this.drawLiftOne();
      this.maxData(this.ab_linking_data)
  },
  methods: {
    maxData:function(data){
      let max_num = 0
      let l_keys = Object.keys(data)
      for(let i = 0; i < l_keys.length; i++){
        let s = l_keys[i]
        max_num = data[s] > max_num ? data[s]:max_num
      }
      return max_num
    },
    maxData2:function(data){
      let max_num = 0
      let l_keys = Object.keys(data)
      for(let i = 0; i < l_keys.length; i=i+2){
        let s = l_keys[i]
        max_num = data[s] > max_num ? data[s]:max_num
      }
      return max_num
    },
    formatTitle:function(v){
      return this.title_dic[v]
      },
    drawMidMap:function(){
      // 基于准备好的dom，初始化echarts实例
              let myChart = this.$echarts.init(document.getElementById('mid_chart'))
              // 绘制图表
              myChart.setOption({
                legend: {
                    data:['Not match','VDNA verified','Manual verified']
                },
                tooltip : {//过滤掉统计的series
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : ['7-1','7-2','7-3','7-4','7-5','7-6','7-7']
                    }
                ],
                yAxis : [
                    {type : 'value'}
                ],
                series : [
                    {
                        name:'Manual verified',
                        type:'bar',
                        color:'#66ff66',
                        stack: '1',
                        data:[500, 111, 171, 174, 490, 230, 110]
                    },
                    {
                        name:'VDNA verified',
                        type:'bar',
                        color:'#fd66ff',
                        stack: '1',
                        data:[620, 332, 301, 334, 590, 330, 420]
                    },{
                        name:'Not match',
                        type:'bar',
                        color:'#b3b3b3',
                        barWidth : 20,
                        stack: '1',
                        data:[620, 732, 701, 734, 1090, 1130, 1120]
                    },
                ]
              });
    },
    drawMaxMap:function(){
      // 基于准备好的dom，初始化echarts实例
              let myChart = this.$echarts.init(document.getElementById('max_chart'))
              // 绘制图表
              myChart.setOption({
                legend: {
                    data:['Infringing URLs','Mapping records'],
                },
                tooltip : {//过滤掉统计的series
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : ['29','30','31','7-1','2','3','4']
                    }
                ],
                yAxis : [
                    {type : 'value'}
                ],
                series : [
                    {
                        name:'Infringing URLs',
                        type:'line',
                        color:'#fd8008',
                        stack: '2',
                        data:[500, 111, 171, 174, 490, 420, 510]
                    },
                    {
                        name:'Mapping records',
                        type:'line',
                        color:'#66ccff',
                        stack: '1',
                        data:[620, 332, 301, 334, 590, 330, 420]
                    }
                ]
              });
    },
    drawLiftOne:function(){
      // 基于准备好的dom，初始化echarts实例
              let myChart = this.$echarts.init(document.getElementById('left_one_chart'))
              // 绘制图表
              myChart.setOption({
                tooltip : {//过滤掉统计的series
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : ['29','30','31','7-1','2','3','4']
                    }
                ],
                yAxis : [
                  {
                    axisLabel:{
                      formatter: function(){return '';}
                    }
                  }
                ],
                series : [
                    {
                        name:'Infringing URLs',
                        type:'line',
                        color:'#fd8008',
                        stack: '2',
                        data:[500, 111, 171, 174, 490, 420, 510]
                    },
                    {
                        name:'Mapping records',
                        type:'line',
                        color:'#66ccff',
                        stack: '1',
                        data:[620, 332, 301, 334, 590, 330, 420]
                    }
                ]
              });
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dashboard{
    position: relative;
    background-color: #ffffff;
  }
  .mini-box{
    width: 18%;
    height: 23%;
    background-color: #e6e6e6;
    box-shadow: 0.325rem 0.325rem 0.225rem #808080;
    position: absolute;
  }
  .mini-box-title{
    position: absolute;
    text-align: left;
    left: 10px;
    top: 2px;
    font-size: 0.9vw;
    font-weight: 900;
  }
  .mid-box{
    width: 60%;
    height: 30%;
    background-color: #e6e6e6;
    box-shadow: 0.325rem 0.325rem 0.225rem #808080;
    position: absolute;
  }
  .max-box{
    width: 60%;
    height: 64%;
    background-color: #e6e6e6;
    box-shadow: 0.325rem 0.325rem 0.225rem #808080;
    position: absolute;
  }
  .lf1{left:1%;}
  .lf2{left:20%;}
  .lf3{left:81%;}
  .tp1{top:2%;}
  .tp2{top:27%;}
  .tp3{top:51%;}
  .tp4{top:75%;}
  .p_abs{position: absolute;}

  .lf_4{left: 4%;}
  .lf_5{left: 5%;}
  .lf_15{left:15%;}
  .lf_20{left: 20%;}
  .lf_25{left: 25%;}
  .lf_35{left: 35%;}
  .lf_55{left: 55%;}
  .lf_60{left: 60%;}

  .tp_15{top:15%;}
  .tp_20{top:20%;}
  .tp_20{top:20%;}
  .tp_25{top:25%;}
  .tp_30{top:30%;}
  .tp_35{top:35%;}
  .tp_40{top:40%;}
  .tp_45{top:45%;}
  .tp_50{top:50%;}
  .tp_55{top:55%;}
  .tp_60{top:60%;}
  .tp_65{top:65%;}
  .tp_75{top:75%;}

  .wh100{width: 100%;}
  .wh46{width: 46%;}
  .hh100{height: 100%;}
  .hh18{height: 18%;}
  .hh13{height: 13%;}
  .hh9{height: 9%;}
  .hh80{height: 80%;}
  .hh90{height: 90%;}

  .ftsize50{font-size: 3vw;font-weight: 500;}
  .ftsize40{font-size: 2.5vw;font-weight: 500;}
  .ftsize25{font-size: 1.2vw;font-weight: 500;}
  .ftsize20{font-size: 1vw;font-weight: 600;}
  .ftsize15{font-size: 0.8vw;}
  .ftsize10{font-size: 0.5vw;}
  .ftsize5{font-size: xx-small;}
  .ft_bold{font-weight: bold;}

  .tx_l{text-align: left;}
  .tx_r{text-align: right;}
  .tx_c{text-align: center;}
  .flt_l{float: left;}
  .ftred{color:#FC0107;}
  .bgc_pink{background-color: #fd6666;}
  .bdr_pink{border-style: solid;border-color: #fd6666;border-width: 0.0625rem 0 0.0625rem 0;}

  .tpm2{top:68%;}
</style>



// WEBPACK FOOTER //
// src/components/monitoring.vue